/**
 * Typed errors for GS1 parsing and validation.
 *
 * The resolver maps these onto RFC 9457 problem bodies, so the `code` is part
 * of a public contract: it reaches field reports and support tickets. Renaming
 * one is a breaking change even though nothing here is exported to npm.
 *
 * Carrying a code rather than only a message is what makes a 400 diagnosable
 * from a log line — spec §15.3's requirement that legacy compression be
 * *nameable* generalises to every rejection reason.
 */
/**
 * A GS1 validation failure.
 *
 * Deliberately extends Error rather than being a plain object: these propagate
 * through the resolver's parse step, and a thrown value that is not an Error
 * loses its stack in every logger we use.
 */
export class GS1Error extends Error {
    code;
    /** The AI this failure relates to, when the failure happened inside one. */
    ai;
    constructor(code, message, ai) {
        super(message);
        this.name = "GS1Error";
        this.code = code;
        this.ai = ai;
    }
}
//# sourceMappingURL=errors.js.map